import React,{useState,useEffect} from 'react'
import Dashboard from '../../components/dashboard/Dashboard'
import TaxComparison from '../../components/dashboard/TaxComparison'
import ReturnStatus from '../../components/dashboard/ReturnStatus'
import TaxableStatus from '../../components/dashboard/TaxableStatus'
import { motion } from 'framer-motion'
const Home = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  
    useEffect(()=>{
      const isSidebarOpen = localStorage.getItem('isSidebarOpen') === 'true'
      setIsSidebarOpen(isSidebarOpen)
    },[])
  return (
    <Dashboard>
      <div className="grid gap-6 lg:grid-cols-3">
              <div className="lg:col-span-2">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <TaxComparison />
                </motion.div>
              </div>
              
              <div className="space-y-6">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <ReturnStatus />
                </motion.div>
                
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                >
                  <TaxableStatus />
                </motion.div>
              </div>
            </div>
    </Dashboard>
  )
}

export default Home